import React from 'react';
import ProcessBar from 'components/ProcessBar';
import InsureProcessCalc from 'components/InsureProcess/Travel/InsureProcessCalc';
import InsureProcessFill1st from 'components/InsureProcess/Travel/InsureProcessFill1st';
import InsureProcessFill2nd from 'components/InsureProcess/Travel/InsureProcessFill2nd';
import InsureProcessPreview from 'components/InsureProcess/Travel/InsureProcessPreview';
import InsureProcessPayment from 'components/InsureProcess/Travel/InsureProcessPayment';
import InsureProcessSuccess from 'components/InsureProcess/Travel/InsureProcessSuccess';
import SliderBoundless from 'components/SliderBoundless';
import { IProps, IState } from './types';
import { InsProcessStep } from 'constants/enums/insProcessStep.enum';
import service from 'bff/services/travelProductService';
import apiCommonService from 'bff/services/commonService';
import {
  Activities,
  Activity,
  Code,
  EmailDomain,
  Inscat,
  KycClaim,
  Occupation,
  Postcode,
  SysOption,
  TravelWarning
} from 'bff/models/info';
import _ from 'lodash';
import { connect } from 'react-redux';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import storageService from 'utils/storageService';
import { AddFavoriteItem, MemberProfile } from 'bff/models/member';
import { Dispatch } from 'redux';
import { RootReducersState } from 'redux/reducers';
import { addFavoriteItem, removeFavoriteItem, unloginAddItem } from 'redux/actions/components/myFavorite.action';
import { Link } from 'bff/models/link';
import { AgeLimitcnd, DATAReqContent, EvalReq, EvalRes, PolicyAddEnListReq, PolicyAddReq, PolicyFeeReq } from 'bff/models/product';
import { EvalExpans } from 'constants/models/evalExpans';
import sweetAlertService from 'utils/sweetAlertService';
import { InsType } from 'constants/enums/insType.enum';
import { ApplyType } from 'constants/enums/applyType.enum';
import OTPVerificationForm from 'components/OTPVerificationForm';
import { OTPInfo } from 'bff/models/login';
import { PaymentMethod } from 'bff/models/product/paymentMethod';
import { SactionType } from 'constants/enums/sactionType.enum';
import { ICalcFormValue } from 'constants/models/components/insurProcess/insureProcessCalc';
import { IFill1stFormValue, IFill1stState, TravelWarningExpandData } from 'constants/models/components/insurProcess/insureProcessFill1st';
import { IFill2ndFormValue, IFill2ndState } from 'constants/models/components/insurProcess/insureProcessFill2nd';
import { IPaymentFormValue, IPaymentState } from 'constants/models/components/insurProcess/insureProcessPayment';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { RouterSettings } from 'constants/models/routerSettings';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import commonService from 'utils/commonService';
// import moment from 'moment';
import moment from 'moment-timezone';
import { IdInfoType } from 'constants/enums/idInfoType.enum';
import { TravelPlanType } from 'constants/enums/travelPlanType.enum';
import { InsureProcessTemp } from 'constants/models/insureProcessTemp';
import apiService from '../../../bff/services/apiService';
import { CodeClass } from '../../../constants/enums/codeClass.enum';
import { DataLayerArgs } from 'react-gtm-module';
import { helperArgGTM, pushGTM } from 'plugins/gtmService';
import { setFillPassportModalVisibleAction } from 'redux/actions/modal.action';
import { InsuredState } from 'components/FillPassportModal/types';

const initState: IState = {
  inscat: {} as Inscat,
  activeStep: 0 as InsProcessStep,
  products: {
    PRODUCT: new Array(0),
    SPI_ATTACH: new Array(0)
  },
  insTypeId: '',
  insTypeName: '',
  prodId: '',
  programId: '',
  UICode: new Array(0),
  travelWarnings: new Array(0),
  tempCalc: {},
  tempFill1st: {},
  tempFill2nd: {},
  tempPayment: {},
  addEnListReq: null
};

class InsureProcessTravel extends React.Component<IProps, IState> {
  state: IState = initState;
  componentDidMount = async () => {
    // #region 判斷來源是否為後台

    if (this.props.match.params.uuid) {
      storageService.removeItem(storageKeys.InsurceProcessState);
      const boPaybyRes = await apiCommonService.boPayby(this.props.match.params.uuid);

      if (typeof boPaybyRes === 'string') {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: `${boPaybyRes}`
        }).then(() => {
          this.props.history.replace(RouterSettings.Home);
        });
        return;
      }

      const initSettingRes = await service.fetchInitSetting(InsType.Travel);

      this.setState({
        boPayby: { ...boPaybyRes },
        products: { ...initSettingRes.products },
        UICode: [...initSettingRes.UICode],
        travelWarnings: [...initSettingRes.travelWarnings],
        insTypeId: boPaybyRes.INS_TYPE_ID,
        insTypeName: initSettingRes.inscat.INS_TYPE_NAME,
        prodId: boPaybyRes.PROD_ID
      });

      await this.handleInitPayment(boPaybyRes.APPLY_NO);

      return;
    }

    // #endregion

    // 預設試算險種類別為旅平險
    let insTypeIdVal: string = InsType.Travel;
    // 商品 Id
    let prodIdVal: string = '';
    // 專案代碼
    let programIdVal: string = '';
    if (storageService.getItem(storageKeys.TravelActiveProdId)) {
      const temp = JSON.parse(storageService.getItem(storageKeys.TravelActiveProdId)) as InsureProcessTemp;

      prodIdVal = temp.PROD_ID || '';
      insTypeIdVal = temp.INS_TYPE_ID || InsType.Travel;
      programIdVal = temp.PROGRAM_ID || '';
    }

    // 登入狀態，若為外國人，不可投保 國內 國外 申根
    // 若是清除暫存資料，且導回商品頁
    if (storageService.getItem(storageKeys.MemberId)) {
      const memberId = storageService.getItem(storageKeys.MemberId);
      const validChar = memberId ? memberId[1] : '';

      // 若為外國人，不可投保 國內 國外 申根
      let prodError = validChar &&
        (validChar !== IdInfoType.NationalMale && validChar !== IdInfoType.NationalFemale) &&
        (prodIdVal === TravelPlanType.Domestic || prodIdVal === TravelPlanType.Abroad || prodIdVal === TravelPlanType.NTAG || prodIdVal === TravelPlanType.TBP);

      // 無商品代碼，且有暫存資料，判斷試算頁選取的商品種類，若為外國人，不可投保 國內 國外 申根
      if (!prodIdVal && storageService.getItem(storageKeys.InsurceProcessState)) {
        const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessState));
        const formVal = tempData.tempCalc.tempCalcFormVal as ICalcFormValue;

        prodError = validChar &&
          (validChar !== IdInfoType.NationalMale && validChar !== IdInfoType.NationalFemale) &&
          (formVal.PROD_ID === TravelPlanType.Domestic || formVal.PROD_ID === TravelPlanType.Abroad || formVal.PROD_ID === TravelPlanType.TBP);
      }

      if (prodError) {
        const baseReq = commonService.getApiReqData();
        const reqConfig = commonService.getReqConfig();

        storageService.removeItem(storageKeys.InsurceProcessState);
        const response = await apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI);

        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: response?.TRANRS?.CODES?.find((item:any) => item.CODE_ID === 'W073')?.CODE_VALUE ?? ''
        }).then(() => {
          this.props.history.push(RouterSettings.Product.TravelIns);
        });
        return;
      }
    }

    // #region 判斷有無暫存資料

    // 有暫存資料且暫存資料已到期，刪除暫存資料
    if (storageService.getItem(storageKeys.InsurceProcessState)) {
      const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessState));
      const isChangeProdId = this.handleValidProdIdChange(insTypeIdVal, prodIdVal, tempData);

      if (isChangeProdId || moment().isAfter(tempData.expiredDate)) {
        storageService.removeItem(storageKeys.InsurceProcessState);
      }
    }

    const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessState));
    // const loginInfo = storageService.getItem(storageKeys.LoginInfo);

    if (tempData) {
      this.setState({
        ...tempData,
        programId: tempData.programId ? tempData.programId : programIdVal
      });

      return;
    }

    // #endregion

    // if (!insTypeIdVal || !prodIdVal) {
    //   this.props.history.push(RouterSettings.Product.TravelIns);
    //   return;
    // }

    // #region 基本進入頁面
    const initSettingRes = await service.fetchInitSetting(insTypeIdVal);

    this.setState({
      activeStep: InsProcessStep.InsureProcessCalc,
      products: { ...initSettingRes.products },
      UICode: [...initSettingRes.UICode],
      travelWarnings: [...initSettingRes.travelWarnings],
      insTypeId: insTypeIdVal,
      insTypeName: initSettingRes.inscat.INS_TYPE_NAME,
      prodId: prodIdVal,
      programId: programIdVal
    });

    // const initSettingRes = await service.fetchTempState();
    // this.setState({ ...initSettingRes });

    // #endregion
  }

  componentDidUpdate () {
  }

  /**
   * @description 判斷選取的方案是否改變，決定是否清除暫存
  */
  handleValidProdIdChange = (insTypeId: string, prodId: string, tempData: any) => {
    const formVal = tempData.tempCalc.tempCalcFormVal as ICalcFormValue;
    if (formVal && formVal.PROD_ID) {
      return insTypeId !== formVal.INS_TYPE_ID || prodId !== formVal.PROD_ID;
    }

    return insTypeId !== tempData.insTypeId || prodId !== tempData.prodId;
  }

  /**
   * @description 試算頁頁面結束事件
  */
  handleInsureProcessCalcUnmount = (
    tempCalcFormVal: ICalcFormValue,
    evalReq: EvalReq,
    evalInfo: EvalRes,
    evalExpanData: EvalExpans[],
    travelSysOpts: SysOption[],
    activeTouristArea: string,
    tempTravels: TravelWarningExpandData[],
    explainModalData: string[][],
    explainModalTitleOpts: SysOption[],
    policyAgeLimitOpts: SysOption[],
    insuredAgeLimitOpts: SysOption[]
  ) => {
    const newState = {
      ...this.state,
      tempCalc: {
        ...this.state.tempCalc,
        tempCalcFormVal: { ...tempCalcFormVal },
        evalReq: evalReq,
        evalInfo: evalInfo,
        evalExpanData: evalExpanData,
        travelSysOpts,
        activeTouristArea,
        tempTravels,
        explainModalData,
        explainModalTitleOpts,
        policyAgeLimitOpts,
        insuredAgeLimitOpts
      }
    };

    commonService.storageData(storageKeys.InsurceProcessState, newState);
  }

  handleCalc = (tempCalcFormVal: ICalcFormValue, evalReq: EvalReq, evalInfo: EvalRes,
    evalExpanData: EvalExpans[], maxPeriod: number, travelSysOpts: SysOption[]) => {
    this.setState({
      tempCalc: {
        tempCalcFormVal: {
          ...tempCalcFormVal,
          INSURE_PERIOD: moment(tempCalcFormVal.END_DATE).diff(tempCalcFormVal.START_DATE, 'd')
        },
        evalInfo: { ...evalInfo },
        evalExpanData: [...evalExpanData],
        evalReq: { ...evalReq },
        maxPeriod: maxPeriod,
        travelSysOpts: travelSysOpts
      }
    });

    pushGTM(this.getGtmArg('add_to_cart', tempCalcFormVal, evalExpanData));
  }

  /**
   * @description 初始化 填寫資料 Page 1
  */
  handleInitProcessFill1st = async (
    tempCalcFormVal: ICalcFormValue, evalReq: EvalReq, evalInfo: EvalRes,
    evalExpanData: EvalExpans[], planData: EvalExpans, maxPeriod: number, travelSysOpts: SysOption[],
    activeTouristArea: string, tempTravels: TravelWarningExpandData[], explainModalData: string[][],
    explainModalTitleOpts: SysOption[], policyAgeLimitOpts: SysOption[], insuredAgeLimitOpts: SysOption[]
  ) => {
    const res = await service.fetchInitProcessFill1st();
    this.setState({
      activeStep: InsProcessStep.InsureProcessFill1st,
      tempCalc: {
        tempCalcFormVal: {
          ...tempCalcFormVal,
          INSURE_PERIOD: moment(tempCalcFormVal.END_DATE).diff(tempCalcFormVal.START_DATE, 'd')
        },
        evalInfo: { ...evalInfo },
        evalExpanData: [...evalExpanData],
        planData: { ...planData },
        evalReq: { ...evalReq },
        maxPeriod: maxPeriod,
        travelSysOpts: travelSysOpts,
        activeTouristArea,
        tempTravels,
        explainModalData,
        explainModalTitleOpts,
        policyAgeLimitOpts,
        insuredAgeLimitOpts
      },
      travelWarnings: [...res.travelWarnings],
      docLinks: [...res.docLinks],
      quickClaimCode: [...res.quickClaimCode]
    });

    pushGTM(this.getGtmArg('begin_checkout'));
  }

  /**
   * @description 調整日期，重新試算保費
   */
  handleReCalcFillst = async (planData: EvalExpans, startDate: any, endDate: any) => {
    if (this.state.tempFill2nd.tempFill2ndFormVal) {
      const insureds = this.state.tempFill2nd.tempFill2ndFormVal.INSUREDS;
      if (!(insureds.length === 1 && insureds[0].INSURED_AMT === '')) {
        for (let i = 0; i < insureds.length; i++) {
          const insured = insureds[i];
          if (insured.INSURED_AMT_OPTS) {
            const dataReqContent: DATAReqContent = {
              ID: insured.INSURED_ID,
              BIRTHDAY: moment(insured.INSURED_BIRTHDAY).format('YYYYMMDD'),
              LIFE: +insured.INSURED_AMT,
              MEDICAL: +insured.INSURED_MEDICAL_VALUE,
              MFUNERAL: 0
            };

            // 建立保費計算用 Request Model
            const policyReq: PolicyFeeReq = {
              INS_TYPE_ID: planData.INS_TYPE_ID,
              PROD_ID: planData.PROD_ID,
              PLAN_ID: planData.HEADER.PLAN_ID,
              CLASS: '1',
              START_DATE: moment(startDate).format('YYYYMMDD'),
              END_DATE: moment(endDate).format('YYYYMMDD'),
              DATA: [{ ...dataReqContent }]
            };
            const response = await service.fetchPolocyFee(policyReq);
            if (response && typeof response !== 'string') {
              const fee = response.DATA[0].FEE;
              insureds[i].INSURED_CALC = fee.toString();
            }
          }
        }
        this.setState({
          tempFill2nd: {
            tempFill2ndFormVal: {
              ...this.state.tempFill2nd.tempFill2ndFormVal,
              INSUREDS: insureds
            }
          }
        });
      }
    }
  }

  /**
   * @description 填寫資料 Page 1 頁面結束事件
  */
  handleInitProcessFill1Unmount = (tempFill1stFormVal: IFill1stFormValue, tempFill1stState: IFill1stState) => {
    const newState = {
      ...this.state,
      tempFill1st: {
        tempFill1stFormVal: { ...tempFill1stFormVal },
        tempFill1stState: { ...tempFill1stState }
      },
      tempCalc: { ...tempFill1stState.editedTempCalc }
    };

    commonService.storageData(storageKeys.InsurceProcessState, newState);
  }

  /**
   * @description 填寫資料 Page 1 我要修改方案 事件
  */
  handleOnEditPlan = (tempFill1stFormVal: IFill1stFormValue, tempFill1stState: IFill1stState) => {
    this.setState({
      activeStep: InsProcessStep.InsureProcessCalc,
      tempFill1st: {
        tempFill1stFormVal: {
          ...tempFill1stFormVal,
          TOURIST_COUNTRY: '',
          TOURIST_DESTINATION: ''
        },
        tempFill1stState: {
          ...tempFill1stState,
          activeTouristArea: '',
          tempTravels: new Array(0)
        }
      },
      tempCalc: { ...tempFill1stState.editedTempCalc }
    });
  }

  /**
   * @description 暫存資料填寫頁 2 資料
  */
  handleFill2ndTempData = () => {
    this.setState({ activeStep: 0 });
  }

  /**
   * @description 資料填寫頁 2 頁面結束事件
  */
  handleProcessFill2Unmount = (tempFill2ndFormVal: IFill2ndFormValue, tempFill2ndState: IFill2ndState) => {
    let newState;
    this.state.activeStep
      ? newState = {
        ...this.state,
        tempCalc: {
          ...this.state.tempCalc,
          planData: { ...tempFill2ndState.planData } as EvalExpans,
          maxPeriod: this.state.tempCalc.maxPeriod
        },
        tempFill2nd: {
          tempFill2ndFormVal: { ...tempFill2ndFormVal },
          tempFill2ndState: { ...tempFill2ndState }
        }
      }
      : newState = {
        ...this.state,
        activeStep: InsProcessStep.InsureProcessFill2nd
      }
    ;

    commonService.storageData(storageKeys.InsurceProcessState, newState);
  }

  /**
    * @description 初始化 填寫資料 Page 2
   */
  handleInitProcessFill2nd = async (tempFill1stFormVal: IFill1stFormValue, tempFill1stState: IFill1stState) => {
    const res = await service.fetchInitProcessFill2nd(this.state.insTypeId, tempFill1stState.editedTempCalc?.tempCalcFormVal?.PROD_ID as string);
    this.setState({
      activeStep: InsProcessStep.InsureProcessFill2nd,
      tempCalc: {
        ...tempFill1stState.editedTempCalc,
        maxPeriod: this.state.tempCalc.maxPeriod
      },
      tempFill1st: {
        tempFill1stFormVal: { ...tempFill1stFormVal },
        tempFill1stState: { ...tempFill1stState }
      },
      kycClaims: [...res.kycClaims],
      occupations: [...res.occupations],
      postcodes: [...res.postcodes],
      emailDomains: [...res.emailDomains],
      ageLimitcnd: { ...res.ageLimitcnd }
    });
  }

  /**
   * @description 資料填寫頁 2 回到 資料填寫頁 1
  */
  handleProcessFill2GoBack = (tempFill2ndFormVal: IFill2ndFormValue, tempFill2ndState: IFill2ndState) => {
    this.setState({
      activeStep: InsProcessStep.InsureProcessFill1st,
      tempCalc: {
        ...this.state.tempCalc,
        planData: { ...tempFill2ndState.planData } as EvalExpans,
        maxPeriod: this.state.tempCalc.maxPeriod
      },
      tempFill2nd: {
        tempFill2ndFormVal: { ...tempFill2ndFormVal },
        tempFill2ndState: { ...tempFill2ndState }
      }
    });
  }

  /**
   * @description 初始化資料預覽頁
  */
  handleInitProcessPreview = (tempFill2ndFormVal: IFill2ndFormValue, tempFill2ndState: IFill2ndState) => {
    this.setState({
      activeStep: InsProcessStep.InsureProcessPreview,
      tempCalc: {
        ...this.state.tempCalc,
        planData: { ...tempFill2ndState.planData } as EvalExpans
      },
      tempFill2nd: {
        tempFill2ndFormVal: { ...tempFill2ndFormVal },
        tempFill2ndState: { ...tempFill2ndState }
      }
    });
  }

  /**
   * @description 資料瀏覽頁點選下一步進行導頁判斷
  */
  handleProcessPreviewNext = async (insTypeId: string, policyAddReq: PolicyAddReq) => {
    // console.warn("🚀 ~ InsureProcess ~ handleProcessPreviewNext part1")
    const applyType = this.state.tempFill2nd.tempFill2ndState?.applyType;
    // 案件來源為網投進行OTP驗證後再導至付款頁
    if (applyType === ApplyType.WebInsured) {
      // 進行 OTP
      await this.handleFetchOTP(false, insTypeId, policyAddReq);
    };

    // 案件來源為網要，不用 OTP 驗證: 新增保單 --> 導至付款頁
    if (applyType === ApplyType.WebRequire) {
      // console.log('案件來源為網要，不用 OTP 驗證: 新增保單 --> 導至付款頁');
      const res = await service.addPolicy(insTypeId, policyAddReq);
      // 若新增保單成功，導至付款頁
      if (res) {
        console.log({ res });
        this.handleFillPassportModal();
        await this.handleInitPayment(this.state.tempFill2nd.tempFill2ndState?.serialNo || '');
      };
    };
  }

  /**
    * @description 取得 OTP 驗證碼方法
    * @param memberProfile 會員基本資料
    * @param isReSent 是否為重新發送
   */
  handleFetchOTP = async (isReSent: boolean, insTypeId?: string, policyAddReq?: PolicyAddReq) => {
    const tempFill2ndFormVal = { ...this.state.tempFill2nd.tempFill2ndFormVal } as IFill2ndFormValue;
    const memberId = tempFill2ndFormVal.MEMBER_ID;
    const mobile = tempFill2ndFormVal.MOBILE;
    const emailAddr = tempFill2ndFormVal.EMAIL_ADDR;

    const result = await apiCommonService.fetchOTP({ MEMBER_ID: memberId, MOBILE: mobile, EMAIL_ADDR: emailAddr } as MemberProfile, SactionType.Insurce, isReSent);
    if (result) {
      this.setState({
        activeStep: InsProcessStep.InsureProcessVerifyOTP,
        otpInfo: { ...result.TRANRS },
        getOTPTime: new Date().getTime(),
        insTypeId: insTypeId ?? '',
        policyAddReq
      });
    }
  }

  /**
    * @description 驗證 OTP 驗證碼方法
    * @param otpVerificationReq OTP 驗證頁 Request Model
   */
  handleVerifyOTP = async (otpCode: string) => {
    const result = await apiCommonService.verifyOTP(this.state.otpInfo as OTPInfo, otpCode, SactionType.Insurce, false);

    if (typeof result === 'string') {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '驗證碼輸入有誤'// 'OTP驗證失敗',
        // html: result
      });

      return;
    }

    if (result && this.state.policyAddReq) {
      const res = await service.addPolicy(this.state.insTypeId, this.state.policyAddReq);
      if (!res) return;
      // 若新增保單成功，導至付款頁
      console.log({ res });
      this.handleFillPassportModal();
      await this.handleInitPayment(this.state.tempFill2nd.tempFill2ndState?.serialNo || '');
    }
  }

  /**
    * @description OTP 驗證碼頁面點選返回上一頁或無法取得驗證碼時的方法
    */
  handleReSetProfile = () => {
    this.setState({
      activeStep: InsProcessStep.InsureProcessPreview,
      otpInfo: undefined,
      getOTPTime: undefined
    });
  };

  /**
   * @description 初始化確認付款頁
   * @param serialNo 要保單號
  */
  handleInitPayment = async (serialNo: string) => {
    const initRes = await service.fetchInitPayment(serialNo, this.state.insTypeId);
    this.setState({
      activeStep: InsProcessStep.InsureProcessPayment,
      paymentMethod: { ...initRes.paymentMethod },
      barcodeNoteCodes: [...initRes.barcodeNoteCodes],
      barcodeNoticeCodes: [...initRes.barcodeNoticeCodes]
    });
  }

  /**
   * @description 確認付款頁頁面結束事件
   */
  handlePaymentUnmount = (tempPaymentFormVal: IPaymentFormValue, tempPaymentState: IPaymentState) => {
    const newState = {
      ...this.state,
      tempPayment: {
        tempPaymentFormVal: { ...tempPaymentFormVal },
        tempPaymentState: { ...tempPaymentState }
      }
    };

    commonService.storageData(storageKeys.InsurceProcessState, newState);
  }

  /**
   * @description 確認付款頁，返回預覽頁
   */
  handlePaymentGoBack = (tempPaymentFormVal: IPaymentFormValue, tempPaymentState: IPaymentState) => {
    this.setState({
      activeStep: InsProcessStep.InsureProcessPreview,
      tempPayment: {
        tempPaymentFormVal: { ...tempPaymentFormVal },
        tempPaymentState: { ...tempPaymentState }
      }
    });
  }

  /**
   * @description 初始化 成功投保頁
  */
  handleInitProcessSucess = async (tempPaymentFormVal: IPaymentFormValue, tempPaymentState: IPaymentState) => {
    const insTypeId = this.state.boPayby ? this.state.boPayby.INS_TYPE_ID : this.state.insTypeId;
    const res = await service.fetchInitProcessSuccess(insTypeId);

    if (this.state.addEnListReq) await service.addPolicyEnList(this.state.addEnListReq);

    this.setState({
      activeStep: InsProcessStep.InsureProcessSuccess,
      activities: { ...res.activities as Activities },
      tempPayment: {
        tempPaymentFormVal: { ...tempPaymentFormVal },
        tempPaymentState: { ...tempPaymentState }
      },
      insDoneCode: [...res.insDoneCode],
      insDoneBarCode: [...res.insDoneBarCode]
    });

    pushGTM(this.getGtmArg('purchase'));
    storageService.removeItem(storageKeys.InsurceProcessState);
  }

  /**
    * @description 成功投保頁，顯示熱門活動 Slider
   */
  handleCreateSlider = () => {
    let sliderBar;
    if (this.state.activities && this.state.activities.ACTIVITY.length > 0) {
      const child = _.map(this.state.activities.ACTIVITY, (activity: Activity, index: number) => {
        return (
          <SliderBoundless.Item key={index}>
            <a href={activity.ACTIVITY_URL} target="_blank" rel="noopener noreferrer">
              <img src={activity.IMAGE_NAME_PC} alt={activity.TITLE} />
            </a>
          </SliderBoundless.Item>
        );
      });
      sliderBar = (
        <div>
          <div className="insure-process__slider-section">
            <SliderBoundless name="insure-process__slider">
              {child}
            </SliderBoundless>
          </div>
        </div>
      );
    }

    return sliderBar;
  }

  /**
   * @description 取得有投保的保障內容資料
   */
  handleFetchInsuredPolicys = (event: string) => {
    const over15COUNT = +(this.state.tempCalc.tempCalcFormVal?.OVER15_COUNT ?? '0');
    const under15COUNT = +(this.state.tempCalc.tempCalcFormVal?.UNDER15_COUNT ?? '0');

    const over15Variant = this.state.tempCalc.planData?.BODY_O15.map((item) => {
      return item.ROWTITLE + (item.FIELD ?? '');
    }).join(';');
    const under15Variant = this.state.tempCalc.planData?.BODY_U15.map((item) => {
      return item.ROWTITLE + (item.FIELD ?? '');
    }).join(';');

    const policyItem = [];

    if (over15COUNT > 0) {
      policyItem.push({
        title: this.state.tempCalc.planData?.HEADER.TITLE,
        prodId: this.state.tempCalc.planData?.PROD_ID,
        variant: over15Variant,
        item_category: '15歲以上',
        price: event === 'purchase' ? this.state.tempFill2nd.tempFill2ndFormVal?.INSUREDS.filter(insured => !insured.INSURED_IS_UNDER15).reduce((acc, insured) => {
          return acc + parseInt(insured.INSURED_CALC);
        }, 0) : +(this.state.tempCalc.planData?.SUBTOTAL_O15?.reduce((acc, item) => {
          return acc + (+(item.FIELD?.replace(/[^0-9]/ig, '') ?? 0));
        }, 0) ?? 0),
        quantity: over15COUNT
      });
    }

    if (under15COUNT > 0) {
      policyItem.push({
        title: this.state.tempCalc.planData?.HEADER.TITLE,
        prodId: this.state.tempCalc.planData?.PROD_ID,
        variant: under15Variant,
        item_category: '15歲以下',
        price: event === 'purchase' ? this.state.tempFill2nd.tempFill2ndFormVal?.INSUREDS.filter(insured => insured.INSURED_IS_UNDER15).reduce((acc, insured) => {
          return acc + parseInt(insured.INSURED_CALC);
        }, 0) : +(this.state.tempCalc.planData?.SUBTOTAL_U15?.reduce((acc, item) => {
          return acc + (+(item.FIELD?.replace(/[^0-9]/ig, '') ?? 0));
        }, 0) ?? 0),
        quantity: under15COUNT
      });
    }

    return policyItem;
  }

  handleAllPolicyItem = (tempCalcFormVal:ICalcFormValue, evalExpanData: EvalExpans[]) => {
    const over15COUNT = +(tempCalcFormVal.OVER15_COUNT ?? '0');
    const under15COUNT = +(tempCalcFormVal.UNDER15_COUNT ?? '0');

    const policyItem: any[] = [];

    // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-expressions
    evalExpanData.forEach((item:any) => {
      if (over15COUNT) {
        const over15Variant = item.BODY_O15.map((item:any) => {
          return item.ROWTITLE + (item.FIELD ?? '');
        }).join(';');

        policyItem.push({
          title: item.HEADER.TITLE,
          prodId: item.PROD_ID,
          variant: over15Variant,
          item_category: '15歲以上',
          price: +(item.SUBTOTAL_O15[0].FIELD ?? '').replace(/[^0-9]/ig, ''),
          quantity: over15COUNT
        });
      }

      if (under15COUNT) {
        const under15Variant = item.BODY_U15.map((item:any) => {
          return item.ROWTITLE + (item.FIELD ?? '');
        }).join(',');

        policyItem.push({
          title: item.HEADER.TITLE,
          prodId: item.PROD_ID,
          variant: under15Variant,
          item_category: '15歲以下',
          price: +(item.SUBTOTAL_U15[0].FIELD ?? '').replace(/[^0-9]/ig, ''),
          quantity: under15COUNT
        });
      }
    });

    return policyItem;
  }

  handleFillPassportModal = () => {
    // PROD_ID = NTA 國外旅遊險、NTAG 申根保險，則 Lightbox 呈現 英文投保證明頁
    const prodId = this.state.boPayby ? this.state.boPayby.PROD_ID : this.state.tempFill2nd.tempFill2ndState?.planData?.PROD_ID;

    if (prodId === TravelPlanType.Abroad || prodId === TravelPlanType.NTAG) {
      if (this.state.boPayby) {
        this.props.setFillPassportModalVisible(
          true, this.state.boPayby.PAYER_LIST, this.state.boPayby.APPLY_NO, this.setAddEnListReq);
      } else {
        this.props.setFillPassportModalVisible(
          true, this.state.tempFill2nd?.tempFill2ndFormVal?.INSUREDS, this.state.tempFill2nd.tempFill2ndState?.serialNo, this.setAddEnListReq);
      }
    };
  }

  setAddEnListReq = (data: PolicyAddEnListReq | null) => {
    this.setState({ addEnListReq: data });
  }

  getGtmArg = (event:string, tempCalcFormVal:any = this.state.tempCalc.tempCalcFormVal, evalExpanData:any = this.state.tempCalc.evalExpanData): DataLayerArgs => {
    let insuredPolicys = [];

    if (event === 'add_to_cart') {
      insuredPolicys = this.handleAllPolicyItem(tempCalcFormVal, evalExpanData);
    } else {
      insuredPolicys = this.handleFetchInsuredPolicys(event);
    }

    // 取得有投保的項目
    return {
      dataLayer: {
        event: 'td_' + event,
        ga4_event_name: event,
        ecommerce: {
          ...event === 'purchase' ? {
            coupon: this.state.tempCalc.tempCalcFormVal?.PROGRAM_ID || null,
            transaction_id: this.state.tempFill2nd.tempFill2ndState?.serialNo,
            affiliation: helperArgGTM.getAffiliation,
            payment_method: helperArgGTM.getPaymentMethodText(this.state.tempPayment.tempPaymentFormVal?.PAYMENT_METHOD)
          } : {},
          currency: helperArgGTM.getCurrency,
          value: insuredPolicys.reduce((acc, policys) => {
            return acc + policys.price;
          }, 0),
          items: insuredPolicys.map((item) => ({
            item_id: item.prodId ?? null,
            item_name: this.state.products.PRODUCT.find(product => product.PROD_ID === item.prodId)?.PROD_NAME ?? null,
            affiliation: helperArgGTM.getAffiliation,
            coupon: tempCalcFormVal.PROGRAM_ID || null,
            currency: helperArgGTM.getCurrency,
            item_brand: this.state.insTypeName,
            item_category: this.state.products.PRODUCT.find(product => product.PROD_ID === item.prodId)?.PROD_NAME ?? null,
            item_category2: helperArgGTM.getRenewOrNewText(),
            item_category3: helperArgGTM.getBcTypeText(this.state.tempFill2nd.tempFill2ndState?.applyType),
            item_category4: item.item_category,
            item_variant: item.variant,
            price: item.price / item.quantity,
            quantity: item.quantity,
            item_list_name: item.title
          }))
        }
      }
    };
  }

  render () {
    const tempFill2ndFormVal = { ...this.state.tempFill2nd.tempFill2ndFormVal } as IFill2ndFormValue;
    const memberId = tempFill2ndFormVal.MEMBER_ID;
    const mobile = tempFill2ndFormVal.MOBILE;
    const emailAddr = tempFill2ndFormVal.EMAIL_ADDR;

    let activePage;
    let successSlider = null; // 成功投保 - Slider
    switch (this.state.activeStep) {
      case InsProcessStep.InsureProcessSuccess: // 成功投保
        activePage = <InsureProcessSuccess
          tempFill1st={this.state.tempFill1st}
          tempPayment={this.state.tempPayment}
          tempFill2nd={this.state.tempFill2nd}
          insDoneCode={this.state.insDoneCode as Code[]}
          insDoneBarCode={this.state.insDoneBarCode as Code[]}
          boPayby={this.state.boPayby}
          tempState={this.state}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        successSlider = this.handleCreateSlider();
        break;
      case InsProcessStep.InsureProcessPayment: // 確認付款
        activePage = <InsureProcessPayment
          UICode={this.state.UICode as Code[]}
          paymentMethod={this.state.paymentMethod as PaymentMethod}
          barcodeNoteCodes={this.state.barcodeNoteCodes as Code[]}
          barcodeNoticeCodes={this.state.barcodeNoticeCodes as Code[]}
          tempCalc={this.state.tempCalc}
          tempFill1st={this.state.tempFill1st}
          tempFill2nd={this.state.tempFill2nd}
          tempPayment={this.state.tempPayment}
          onSubmit={this.handleInitProcessSucess}
          onGoBack={this.handlePaymentGoBack}
          boPayby={this.state.boPayby}
          tempState={this.state}
          onUnmount={this.handlePaymentUnmount}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case InsProcessStep.InsureProcessVerifyOTP:
        activePage = <OTPVerificationForm
          memberProfile={{ MEMBER_ID: memberId, MOBILE: mobile, EMAIL_ADDR: emailAddr } as MemberProfile}
          memberId={memberId}
          otpInfo={this.state.otpInfo as OTPInfo}
          getOTPTime={this.state.getOTPTime as number}
          UICode={this.state.UICode as Code[]}
          onUnavailableAuth={this.handleReSetProfile}
          onGoBack={this.handleReSetProfile}
          onSubmit={this.handleVerifyOTP}
          onResentOTP={() => this.handleFetchOTP(true)}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case InsProcessStep.InsureProcessPreview: // 資料預覽
        activePage = <InsureProcessPreview
          postcodes={this.state.postcodes as Postcode[]}
          onPreviewCheck={this.handleProcessPreviewNext}
          onGoBack={() => this.setState({ activeStep: InsProcessStep.InsureProcessFill2nd })}
          tempCalcFormVal={this.state.tempCalc.tempCalcFormVal as ICalcFormValue}
          tempFill1st={this.state.tempFill1st}
          tempFill2nd={this.state.tempFill2nd}
          UICode={this.state.UICode}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case InsProcessStep.InsureProcessFill2nd: // 填寫資料 Page 2
        activePage = <InsureProcessFill2nd
          occupations={this.state.occupations as Occupation[]}
          kycClaims={this.state.kycClaims as KycClaim[]}
          postcodes={this.state.postcodes as Postcode[]}
          tempCalc={this.state.tempCalc}
          tempFill1st={this.state.tempFill1st}
          tempFill2nd={this.state.tempFill2nd}
          UICode={this.state.UICode as Code[]}
          emailDomains={this.state.emailDomains as EmailDomain[]}
          onSubmit={this.handleInitProcessPreview}
          onGoBack={this.handleProcessFill2GoBack}
          ageLimitcnd={this.state.ageLimitcnd as AgeLimitcnd}
          tempState={this.state}
          onTempData={this.handleFill2ndTempData}
          onUnmount={this.handleProcessFill2Unmount}
          tempCalcFormVal={this.state.tempCalc.tempCalcFormVal as ICalcFormValue}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case InsProcessStep.InsureProcessFill1st: // 填寫資料 Page 1
        activePage = <InsureProcessFill1st
          tempCalc={this.state.tempCalc}
          tempFill1st={this.state.tempFill1st}
          docLinks={this.state.docLinks as Link[]}
          travelWarnings={this.state.travelWarnings as TravelWarning[]}
          UICode={this.state.UICode as Code[]}
          quickClaimCode={this.state.quickClaimCode as Code[]}
          tempInsureds={this.state.tempFill2nd.tempFill2ndFormVal?.INSUREDS || new Array(0)}
          onReCalcFillst={this.handleReCalcFillst}
          onEditPlan={this.handleOnEditPlan}
          onSubmit={this.handleInitProcessFill2nd}
          tempState={this.state}
          onUnmount={this.handleInitProcessFill1Unmount}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case InsProcessStep.InsureProcessCalc: // 我要試算
        activePage = <InsureProcessCalc
          insTypeId={this.state.insTypeId}
          prodId={this.state.prodId}
          programId={this.state.programId}
          products={this.state.products}
          UICode={this.state.UICode}
          myFavoriteList={this.props.myFavoriteList}
          onAddFavoriteItem={this.props.onAddFavoriteItem}
          onRemoveFavoriteItem={this.props.onRemoveFavoriteItem}
          unloginAddItem={this.props.unloginAddItem}
          tempCalcFormVal={this.state.tempCalc.tempCalcFormVal as ICalcFormValue}
          evalInfo={this.state.tempCalc.evalInfo as EvalRes}
          evalExpanData={this.state.tempCalc.evalExpanData as EvalExpans[]}
          onCalc={this.handleCalc}
          onInsured={this.handleInitProcessFill1st}
          tempState={this.state}
          onUnmount={this.handleInsureProcessCalcUnmount}
          travelWarnings={this.state.travelWarnings as TravelWarning[]}
          activeTouristArea={this.state.tempCalc.activeTouristArea}
          tempTravels={this.state.tempCalc.tempTravels}
          explainModalData={this.state.tempCalc.explainModalData as string[][]}
          explainModalTitleOpts={this.state.tempCalc.explainModalTitleOpts as SysOption[]}
          policyAgeLimitOpts={this.state.tempCalc.policyAgeLimitOpts as SysOption[]}
          insuredAgeLimitOpts={this.state.tempCalc.insuredAgeLimitOpts as SysOption[]}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
    }

    return (
      <div className={`insure-process insure-process--${InsTypeDefinesEN[InsType.Travel]}`}>
        <div className="insure-process__header">
          <ProcessBar activeStep={this.state.activeStep} />
        </div>
        <div className="insure-process__content">
          <div className="template-container">
            <div className="template-content">
              {activePage}
            </div>
          </div>
        </div>

        {/* 成功投保 - Slider */}
        {successSlider}

      </div>
    );
  }
};

const mapStateToProps = (state: RootReducersState) => {
  return {
    myFavoriteList: state.myFavorite.myFavoriteList
  };
};

const mapDisatchToProps = (dispatch: Dispatch) => {
  return {
    onAddFavoriteItem: (item: AddFavoriteItem) => dispatch(addFavoriteItem(item)),
    onRemoveFavoriteItem: (sn: any) => dispatch(removeFavoriteItem(sn)),
    unloginAddItem: (insTypeId: string, prodId: string, planId: string) => dispatch(unloginAddItem(insTypeId, prodId, planId)),
    setFillPassportModalVisible: (visible: boolean, insureds?: InsuredState[], serialNo?: string, setAddEnListReq?: (data: PolicyAddEnListReq) => void) =>
      dispatch(setFillPassportModalVisibleAction(visible, insureds, serialNo, setAddEnListReq))
  };
};

export default connect(mapStateToProps, mapDisatchToProps)(InsureProcessTravel);
